<template>
    <div>       
        <b-tabs>
            <b-tab active>
                <template slot="title">
                    <h6 class="colorEmision">Emision</h6>
                    <div class="separador"></div>
                </template>
                <b-card>
                    <div slot="header">
                        <div class="text-center">
                                <h3 class="display">Comunicación de Baja</h3>
                        </div>
                    </div>
                    <comunicacion-baja-emision></comunicacion-baja-emision>
                </b-card>
            </b-tab>
            <!-- <b-tab title="Emitidas">
                <comunicacion-baja-consulta></comunicacion-baja-consulta>
            </b-tab> -->
        </b-tabs>
    </div>
</template>

<script>
import ComunicacionBajaEmision from '@/components/comunicacionbaja/ComunicacionBajaEmision'
import ComunicacionBajaConsulta from '@/components/comunicacionbaja/ComunicacionBajaConsulta'
export default {
    name: 'ComunicacionBaja',
    components: {
        ComunicacionBajaEmision,
        ComunicacionBajaConsulta
    },
    data: () => {
        return {

        }
    }
}
</script>

